module.exports = __webpack_public_path__ + "img/clients.4c7548b5.png";